import * as React from 'react';
import { useTranslation } from 'react-i18next';
import Modal, { IBaseModalProps as ModalProps } from './Modal.tsx';
import Button from './Button.tsx';
import classnames from '../utils/classnames.tsx';

export interface IProps extends ModalProps {
    onConfirm: () => Promise<void> | void;
    onCancel: () => Promise<void> | void;
    confirmDisabled?: boolean;
    labelConfirm?: string;
    labelCancel?: string;
    danger?: boolean;
}

const ConfirmModal = ({
    children,
    onConfirm,
    onCancel,
    buttons,
    labelConfirm,
    labelCancel,
    danger = false,
    confirmDisabled,
    title,
    className,
    ...modalProps
}: IProps) => {
    const { t } = useTranslation('core');

    buttons = buttons || [
        // default buttons
        <Button key="cancel" onClick={() => onCancel()}>
            {labelCancel ?? t('components.confirmModal.cancel')}
        </Button>,
        <Button
            key="confirm"
            onClick={() => onConfirm()}
            className={classnames(
                danger &&
                    'bg-surface-danger-strong-default hover:enabled:!bg-surface-danger-strong-hover active:enabled:!bg-surface-danger-strong-active focus:enabled:!bg-surface-danger-strong-focus'
            )}
            disabled={confirmDisabled}
            variant="primary"
        >
            {labelConfirm ?? t('components.confirmModal.ok')}
        </Button>,
    ];

    return (
        <Modal
            buttons={buttons}
            onClose={onCancel}
            noHeader={!title}
            title={title}
            className={classnames('sm:max-w-[31.25rem]', className)}
            {...modalProps}
        >
            {children}
        </Modal>
    );
};

export default ConfirmModal;
